import { travelGuideQueryKeys as e } from "./travelGuideQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { travelGuidesApi as r } from "@maat/api-main";
//#region src/travelGuides/useTravelGuideMutations.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: (e) => r.create(e),
		onSuccess: () => {
			i.invalidateQueries({ queryKey: e.list() });
		}
	});
}, a = (i) => {
	let a = n();
	return t({
		mutationFn: (e) => r.uploadCover(i, e),
		onSuccess: () => a.invalidateQueries({ queryKey: e.detail(i) })
	});
}, o = () => {
	let i = n();
	return t({
		mutationFn: ({ guideId: e, data: t }) => r.update(e, t),
		onSuccess: (t, { guideId: n }) => {
			i.invalidateQueries({ queryKey: e.detail(n) }), i.invalidateQueries({ queryKey: e.list() });
		}
	});
}, s = () => {
	let i = n();
	return t({
		mutationFn: (e) => r.remove(e),
		onSuccess: () => {
			i.invalidateQueries({ queryKey: e.list() });
		}
	});
}, c = () => {
	let i = n();
	return t({
		mutationFn: (e) => r.submit(e),
		onSuccess: (t, n) => {
			i.invalidateQueries({ queryKey: e.detail(n) }), i.invalidateQueries({ queryKey: e.list() });
		}
	});
};
//#endregion
export { i as useCreateTravelGuideMutation, s as useDeleteTravelGuideMutation, c as useSubmitTravelGuideMutation, o as useUpdateTravelGuideMutation, a as useUploadGuideCoverMutation };
